import { i18n } from './index';
import type errors from './locales/en-US/errors.json';

export type ValidationKey = keyof typeof errors.validation;

/**
 * Zod error param that reads `errors:validation.<key>` from the catalogue. Zod calls it during
 * `.parse()`, so the message follows the active language.
 */
export function validationMessage(key: ValidationKey): { error: () => string } {
  return { error: () => i18n.t(`errors:validation.${key}`) };
}
